const currency = new Intl.NumberFormat("es-GT", {
  style: "currency",
  currency: "GTQ",
});

export default currency;
